module.exports = __webpack_public_path__ + "img/element-404.3600e5c5.svg";